import React from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import { RedirectAs404 } from "./utils/Utils";
import PrivateRoute from "./route/PrivateRoute";
import Layout from "./layout/Index";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import ForgotPassword from "./pages/auth/ForgotPassword";
import Success from "./pages/auth/Success";
import Check from "./pages/auth/Check";
import CopyLogin from "./pages/auth/CopyLogin";
import BlankPages from "./pages/pre-built/user-manage/BlankPages";


const App = () => {
  return (
    <Switch>
      {/* Auth Pages */}
      <Route exact path={`${process.env.PUBLIC_URL}/auth-success`} component={Success}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/auth-reset`} component={ForgotPassword}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/auth-register`} component={Register}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/Check`} component={Login}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/`} component={CopyLogin}></Route>   
      <Route exact path={`${process.env.PUBLIC_URL}/check`} component={Check}></Route>
      <Route exact path={`${process.env.PUBLIC_URL}/Blankpage`} component={BlankPages}></Route>
      

      
      {/*Main Routes*/}
      <PrivateRoute exact path="" component={Layout}></PrivateRoute>
      <Route component={RedirectAs404}></Route>
    </Switch>
  );
};
export default withRouter(App);
